/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLocationQueryResult } from '../../models/get-location-query-result';

export interface ApiLocationGetLocationGet$Params {
  Id?: string;
}

export function apiLocationGetLocationGet(http: HttpClient, rootUrl: string, params?: ApiLocationGetLocationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetLocationGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLocationQueryResult>;
    })
  );
}

apiLocationGetLocationGet.PATH = '/api/Location/GetLocation';
